import { Data } from '../Data';

export class UserDataService {
    constructor() {
        this.dataService = new Data();
        this.getUser = this.getUser.bind(this);
        this.updateApdConsent = this.updateApdConsent.bind(this);
        this.updateW2Consent = this.updateW2Consent.bind(this);
    }

    getUser() {
        return this.dataService.performAuthenticatedFetch('api/user/self');
    }

    updateW2Consent(consent) {
        const ssnid = this.dataService.getSsnId();
        var json = JSON.stringify({ allowElectronicW2: consent });
        return this.dataService.performAuthenticatedPostAPI('/api/user/updateW2Consent/' + ssnid, json);
    }

    updateApdConsent(consent) {
        const ssnid = this.dataService.getSsnId();
        var json = JSON.stringify({ allowElectronicApd: consent });
        return this.dataService.performAuthenticatedPostAPI('/api/user/updateApdConsent/' + ssnid, json);
    }
    updatePassword(password, confirmPassword) {
        return this.dataService.getUser().then((data) => {
            var json = JSON.stringify({ password: password, confirmPassword: confirmPassword });
            return this.dataService.performAuthenticatedPostAPI('/api/user/updatepassword/' + data.id, json);
        });
    }
    getSecurityQuestions() {
        return this.dataService.performAuthenticatedFetch('/api/account/securityquestions');
    }
    getSecurityQuestionsForUser() {
        const ssnid = this.dataService.getSsnId();
        return this.dataService.performAuthenticatedFetch('/api/account/questions?ssnid=' + ssnid);
    }
    updateSecurityQuestions(questions) {
        const ssnid = this.dataService.getSsnId();
        var json = JSON.stringify(questions);
        return this.dataService.performAuthenticatedPostAPI('/api/account/updatesecurityquestions/' + ssnid, json); // BUG FIX 814
    }
    updateUsernameEmail(information) {
        return this.dataService.getUser().then((userData) => {
            return this.dataService.performAuthenticatedPostAPI('/api/user/updateinformation/' + userData.id,
                JSON.stringify(information));
        });
    }

    updateUserImage(image) {
        const userid = this.dataService.getUserId();
        let formData = new FormData();
        formData.append("image", image);
        // TODO: Combine this with the method in Data.js.
        // We don't want to set the content-type explicitly here.
        var accesstoken = localStorage.getItem('accesstoken');
        if (!accesstoken) {
            window.location = "/login"
        }
        return fetch('/api/user/updatePicture/' + userid, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + accesstoken
            },
            body: formData
        })
            .catch(function (e) { console.error(e) });
    }

    getProfileImage() {
        const userid = this.dataService.getUserId();
        return this.dataService.performAuthenticatedDownload('/api/user/getPicture/' + userid);
    }

    removeProfilePicture() {
        const userid = this.dataService.getUserId();
        return this.dataService.performAuthenticatedDelete('/api/user/deletePicture/' + userid);
    }

    getTheme() {
        const userid = this.dataService.getUserId();
        return this.dataService.performAuthenticatedFetch('/api/user/getTheme/' + userid);
    }

    setTheme(theme) {
        const userid = this.dataService.getUserId();
        return this.dataService.performAuthenticatedPostAPI('/api/user/updateTheme/' + userid,
            JSON.stringify({ theme: theme }));
    }
}